<template>
  <div class="row pt-3">
    <div class="col-12">
      <div class="row">
        <div
          v-for="entry in pictures"
          :key="entry.id"
          class="col-md-3 col-xs-12"
        >
          <media-entry
            :entry="entry"
            @destroy="destroy(entry)"
            @setPrimary="setPrimary(entry)"
          ></media-entry>
        </div>
      </div>
      <hr />
      <div class="row pt-3 pb-3">
        <div
          v-for="entry in audioFiles"
          :key="entry.id"
          class="col-md-3 col-xs-12"
        >
          <media-entry
            :entry="entry"
            @destroy="destroy(entry)"
            @setPrimary="setPrimary(entry)"
          ></media-entry>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    profile: {
      profile: true,
      type: Object
    },
  },
  data() {
    return {
      media: [],
    }
  },
  created() {
    this.media = Object.assign([], this.profile.media);
    this.$bus.$on("media-uploaded", mediaElement => {
      if (mediaElement) {
        this.media.push(mediaElement);
      }
    });
  },
  methods: {
    destroy(entry) {
      entry.deleting = true;
      const ajax = this.$http.delete(entry.delete_url);
      const transition = new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 1000);
      });

      Promise.all([ajax, transition]).then(() => {
        let index = this.media.indexOf(entry);
        this.$delete(this.media, index);
      });
    },
    setPrimary(entry) {
      entry.settingPrimary = true;
      let idx = entry.is_image ?
        this.media.findIndex(el => {return (el.is_primary && el.is_image); }) :
        this.media.findIndex(el => {return (el.is_primary && el.is_audio); });
      if(idx>=0)
        this.media[idx].is_primary = false;
      this.$http.post(entry.primary_url).then((resp) => {
        let idx = this.media.findIndex(el => el.id === entry.id);
        this.$set(this.media, idx, resp.data);
      }).finally(() => {entry.settingPrimary = true;});
    },
  },
  computed: {
    audioFiles() {
      return this.media.filter(media => {
        return media.is_audio;
      });
    },
    pictures() {
      return this.media.filter(media => {
        return media.is_image;
      });
    }
  },
}
</script>
